// removed by extract-text-webpack-plugin
module.exports = {"variables":"\"../../../assets/stylesheets/variables.css\"","lightRed":"#ff3f56","mediumMinWidth":"992px","mediumMaxWidth":"1199px","small":"_22zGKWmKy0aZd_9Ue1eYfN","smallMinWidth":"768px","smallMaxWidth":"991px","largeMinWidth":"1200px","extraSmallMinWidth":"576px","extraSmallMaxWidth":"767px","mobileThreshold":"575px","container":"_8WIDAK6_uDaWVy9kFVtld","link":"_3z7-w1SpMH_y6up3VnF-wp","image":"mwjGdFiiFtyMeI_Qkeq-v","containerWithPopUp":"gFwYTjzxhmY5eeuDGECFI","badge":"_2fSY2RudsC2zNHdvi_DYox _22zGKWmKy0aZd_9Ue1eYfN","popUp":"MJWMUM-IhdbVUpCHn0Tg6"};


//////////////////
// WEBPACK FOOTER
// ./src/common/home-navbar/cart-button/CartButton.css
// module id = 395
// module chunks = 0 1 2